import {Directive, HostListener, ElementRef} from '@angular/core';

@Directive({
  selector: '[appPhoneMask]'
})
export class PhoneMaskDirective {

  el = null;

  constructor(private elementRef: ElementRef) {
    this.el = elementRef.nativeElement;
  }

  @HostListener('keyup', ['$event'])
  inputChange(event) {
    let elText: string = event.target.value;
    elText = elText.replace(/[^0123456789*#]/g, '');
    if (elText.length <= 4) {
      event.target.value = elText;
    } else if (elText.length <= 9) {
      event.target.value = elText.replace(/^(9)?([0-9*#]{0,4})([0-9*#]{4})$/g, '$1$2-$3');
    } else if (elText.length <= 11) {
      event.target.value = elText.replace(/^(0)?([1-9*#]{2})(9)?([0-9*#]{4})([0-9*#]{4})$/g, '$2 $3$4-$5');
    }
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/phone-mask.directive.ts